module.exports = __webpack_public_path__ + "static/media/countdown.04b13f24.png";